import { Link } from 'react-router-dom';
import { movieCategories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-accent-500 text-2xl"><i className="ri-movie-2-fill"></i></span>
              <span className="font-heading text-xl font-semibold text-white">被窝影院</span>
            </div>
            <p className="text-sm text-foreground-400 leading-relaxed">
              被窝影院电影大全免费看，最新电影免费看和高分电影在线，无广告不缓冲，满足各类影迷需求。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">电影分类</h4>
            <div className="grid grid-cols-2 gap-2">
              {movieCategories.filter(c => c.slug !== 'all').map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">首页</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
              <Link to="/category/all" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">全部电影</Link>
              <Link to="/category/scifi" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">科幻电影</Link>
              <Link to="/category/action" className="text-sm text-foreground-400 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer">动作电影</Link>
            </div>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-white mb-4">联系我们</h4>
            <div className="flex flex-col gap-2 text-sm text-foreground-400">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-500"></i>
                <span>contact@beiwocinema.com</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-phone-line text-accent-500"></i>
                <span>400-888-0000</span>
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-map-pin-line text-accent-500"></i>
                <span>北京市朝阳区影视产业园</span>
              </p>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-700/30 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-500">
            &copy; {new Date().getFullYear()} 被窝影院 版权所有 | 京ICP备XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-foreground-500 hover:text-accent-400 transition-colors cursor-pointer" aria-label="B站">
              <i className="ri-bilibili-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}